/** Fixed backend field on journey and event rows (not an additional-column UUID). */
export const NOTES_FIELD = "notes" as const;
